import { Component, OnInit } from '@angular/core';
import { LoaderSpinnerService } from '@carm/_core/interceptors/loader-spinner.service';

@Component({
  selector: 'carm-load-spinner-wrapper',
  templateUrl: './load-spinner-wrapper.component.html',
  styleUrls: ['./load-spinner-wrapper.component.scss']
})
export class LoadSpinnerWrapperComponent implements OnInit {

  constructor(public loaderSpinnerService: LoaderSpinnerService) { }

  ngOnInit(): void {
  }

}
